var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }, [_c("w-spacer")], 1),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12", md: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [
                        _vm._v(_vm._s(_vm.$ct("notifications"))),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12" } },
                                [
                                  _c("w-switch", {
                                    attrs: {
                                      value:
                                        _vm.settings
                                          .NotifyOnFrequencyDocumentCreated,
                                      space: "",
                                      label: _vm.$ct(
                                        "on-frequency-document-created"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onFrequencyDocumentCreatedChanged(
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _c("w-switch", {
                                    attrs: {
                                      value:
                                        _vm.settings
                                          .NotifyOnFrequencyDocumentSent,
                                      space: "",
                                      label: _vm.$ct(
                                        "on-frequency-document-sent"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onFrequencyDocumentSentChanged(
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _c("w-switch", {
                                    attrs: {
                                      value: _vm.settings.NotifyOnReminderSent,
                                      space: "",
                                      label: _vm.$ct(
                                        "on-automatic-reminder-sent"
                                      ),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onReminderSentChanged($event)
                                      },
                                    },
                                  }),
                                  _c("w-switch", {
                                    attrs: {
                                      value: _vm.settings.NotifyOnPeppolReceive,
                                      space: "",
                                      label: _vm.$ct("on-peppol-receive"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onPeppolReceiveChanged(
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _c("w-switch", {
                                    attrs: {
                                      value:
                                        _vm.settings.EmailNotifyOnPeppolReceive,
                                      space: "",
                                      label: _vm.$ct("email-on-peppol-receive"),
                                    },
                                    on: {
                                      input: function ($event) {
                                        return _vm.onEmailPeppolReceiveChanged(
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                  _vm.settings.EmailNotifyOnPeppolReceive
                                    ? _c("w-input", {
                                        staticClass: "mt",
                                        attrs: {
                                          value: _vm.peppolNotificationEmail,
                                          label: _vm.$ct(
                                            "peppol-notification-email"
                                          ),
                                          fancy: "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onPeppolNotificationEmailChanged(
                                              $event
                                            )
                                          },
                                          blur: _vm.updateSettings,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isOwner
                ? _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(
                              _vm._s(_vm.$ct("sale-delete-notifications"))
                            ),
                          ]),
                          _c(
                            "w-card-content",
                            [
                              _c("AppSaleTypeMultiSelect", {
                                attrs: {
                                  value:
                                    _vm.dossierConfig
                                      .NotifyOwnerOnSaleDeleteTypes,
                                  label: _vm.$ct("notify-on-sale-delete"),
                                  "use-id": "",
                                  "use-purchase-and-sale": "",
                                  fancy: "",
                                },
                                on: { input: _vm.onNotifyTypesChanged },
                              }),
                              _c("div", { staticClass: "mt" }),
                              _c("AppSaleTypeMultiSelect", {
                                attrs: {
                                  value:
                                    _vm.dossierConfig
                                      .EmailOwnerOnSaleDeleteTypes,
                                  label: _vm.$ct("email-on-sale-delete"),
                                  "use-id": "",
                                  "use-purchase-and-sale": "",
                                  fancy: "",
                                },
                                on: { input: _vm.onEmailTypesChanged },
                              }),
                              _c("div", { staticClass: "mt" }),
                              _c("label", { staticClass: "w-label" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$ct("sale-delete-notification-emails")
                                  )
                                ),
                              ]),
                              _vm._l(
                                _vm.notificationEmails,
                                function (email, i) {
                                  return _c(
                                    "w-row",
                                    {
                                      key: i,
                                      staticClass: "email-row",
                                      attrs: { "no-margin": "" },
                                    },
                                    [
                                      _c("w-input", {
                                        ref: "emailInputs",
                                        refInFor: true,
                                        staticClass: "email-input",
                                        attrs: {
                                          value: email,
                                          label: "E-mail " + (i + 1),
                                          fancy: "",
                                        },
                                        on: {
                                          input: function ($event) {
                                            return _vm.onEmailInput(i, $event)
                                          },
                                          blur: _vm.onEmailBlur,
                                          keydown: function ($event) {
                                            return _vm.onEmailKeyDown($event)
                                          },
                                        },
                                      }),
                                      _vm.notificationEmails.length > 1
                                        ? _c(
                                            "w-button",
                                            {
                                              staticClass: "danger",
                                              attrs: { flat: "" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.removeEmail(i)
                                                },
                                              },
                                            },
                                            [
                                              _c("w-fa", {
                                                attrs: { icon: "trash" },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                }
                              ),
                              _c(
                                "w-link",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.addEmail()
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", { attrs: { icon: "plus" } }),
                                  _vm._v(
                                    " " + _vm._s(_vm.$ct("add-email-address"))
                                  ),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.isDevMode
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12", md: "6" } },
                    [
                      _c(
                        "w-card",
                        [
                          _c("w-card-title", [
                            _vm._v(_vm._s(_vm.$ct("toolbar-iframe.title"))),
                          ]),
                          _c(
                            "w-card-content",
                            [
                              _c(
                                "w-row",
                                [
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-input", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct("toolbar-iframe.url"),
                                        },
                                        model: {
                                          value: _vm.settings.ToolbarIframe.Url,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings.ToolbarIframe,
                                              "Url",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings.ToolbarIframe.Url",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct(
                                            "toolbar-iframe.no-border"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.settings.ToolbarIframe.NoBorder,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings.ToolbarIframe,
                                              "NoBorder",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings.ToolbarIframe.NoBorder",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-checkbox", {
                                        attrs: {
                                          fancy: "",
                                          label: _vm.$ct(
                                            "toolbar-iframe.use-desktop-proxy"
                                          ),
                                        },
                                        model: {
                                          value:
                                            _vm.settings.ToolbarIframe
                                              .UseDesktopAppAsProxy,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings.ToolbarIframe,
                                              "UseDesktopAppAsProxy",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings.ToolbarIframe.UseDesktopAppAsProxy",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "w-col",
                                    { attrs: { xs: "12" } },
                                    [
                                      _c("w-select", {
                                        attrs: {
                                          items: [
                                            {
                                              text: "Flex (volledige breedte)",
                                              value: "flex",
                                            },
                                            {
                                              text: "Vaste breedte",
                                              value: "fixed",
                                            },
                                          ],
                                          fancy: "",
                                          label: "Breedte",
                                        },
                                        model: {
                                          value:
                                            _vm.settings.ToolbarIframe
                                              .WidthMode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.settings.ToolbarIframe,
                                              "WidthMode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "settings.ToolbarIframe.WidthMode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.settings.ToolbarIframe.WidthMode ===
                                  "fixed"
                                    ? _c(
                                        "w-col",
                                        { attrs: { xs: "12" } },
                                        [
                                          _c("w-input", {
                                            attrs: {
                                              fancy: "",
                                              type: "number",
                                              label: _vm.$ct(
                                                "toolbar-iframe.fixed-width"
                                              ),
                                            },
                                            model: {
                                              value:
                                                _vm.settings.ToolbarIframe
                                                  .FixedWidth,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.settings.ToolbarIframe,
                                                  "FixedWidth",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "settings.ToolbarIframe.FixedWidth",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-card-actions",
                            [
                              _c("w-spacer"),
                              _c(
                                "w-button",
                                {
                                  attrs: { icon: "save" },
                                  on: { click: _vm.updateSettings },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("common.save")) + " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }